import styles from "../MoveOutChecklist.module.css";
import { TextField } from "@mui/material";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { Plus, Trash2 } from "react-feather";
import { PhaseBanner } from "./CommonComponents";

const DamageCostTab = ({ moveoutData, submitMoveoutChceckList }) => {
    const { control, watch, handleSubmit } = useForm({
        defaultValues: {
            damages: moveoutData?.damages?.map(i => {
                return { description: i?.description, cost: i?.cost }
            }) || []
        }
    });

    const { fields, append, remove } = useFieldArray({
        control,
        name: "damages"
    });

    const onSubmit = (data) => {
        let postdata = { current_step: 4, damage_cost: 0 };

        let damage_cost = 0;

        if (data?.damages) {
            data?.damages?.forEach(i => {
                damage_cost += parseFloat(i?.cost);
            });

            postdata = { ...postdata, damages: data?.damages, damage_cost: damage_cost };
        }

        submitMoveoutChceckList(postdata);
    }

    const damageList = watch("damages") || [];

    const totalDamageCost = damageList.reduce((total, item) => {
        return total + (parseFloat(item?.cost) || 0);
    }, 0);

    return <div className={`${styles.tp} ${styles.tpActive}`}>
        <PhaseBanner
            type="green"
            icon="clipboard-check"
            title="Phase 2 — Inspection in progress"
            sub="Walk through each room. Complete add damage costs before generating the final statement."
        />
        <form onSubmit={handleSubmit(onSubmit)}>
            <div>
                <table className={styles.dmgTable}>
                    <thead>
                        <tr>
                            <th>Description</th>
                            <th>Cost ($)</th>
                            <th style={{ width: 36 }} />
                        </tr>
                    </thead>
                    <tbody>
                        {fields.map((field, i) => (<tr key={field.id}>
                            <td>
                                <div className={`${styles.DamageFullField} FormGroup`}>
                                    <Controller
                                        name={`damages.${i}.description`}
                                        control={control}
                                        render={(props) => (<TextField {...props} placeholder={"Damage description "} />)}
                                    />
                                </div>
                            </td>

                            <td>
                                <div className={`${styles.DamageFullField} FormGroup`}>
                                    <Controller
                                        name={`damages.${i}.cost`}
                                        control={control}
                                        render={(props) => (<TextField {...props} type="number" min="0" step="0.01" placeholder={"Cost"} />)}
                                    />
                                </div>

                            </td>

                            <td>
                                <button type="button" className={styles.iconBtn} onClick={() => remove(i)}>
                                    <Trash2 />
                                </button>
                            </td>
                        </tr>))}
                    </tbody>
                </table>
                <button type="button" className={styles.addLink} onClick={() => append({ description: "", cost: 0 })}>
                    <Plus /> Add item
                </button>
                <div className={styles.dmgTotalRow}>
                    <span className={styles.dmgTotalLabel}>Tenant-chargeable total</span>
                    <span className={styles.dmgTotalVal}>{new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(totalDamageCost)}</span>
                </div>
            </div>


            <div className={styles.fa}>
                <span className={styles.faSpacer} />
                <button className={`${styles.btn} ${styles.btnP}`} type="submit">
                    Generate final statement <i className="ti ti-arrow-right" />
                </button>
            </div>
        </form>
    </div>
}

export default DamageCostTab;